export default (state) => state.authentication.transferToken
